"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getConnectCampaignToSFStatusEpic = exports.connectCampaignToSFEpic = void 0;

var _reduxObservable = require("redux-observable");

var _operators = require("rxjs/operators");

var _services = require("@alycecom/services");

var _connectToSF = require("./connectToSF.actions");

var connectCampaignToSFEpic = function connectCampaignToSFEpic(action$, state$, _ref) {
  var salesforceApiService = _ref.salesforceApiService;
  return action$.pipe((0, _reduxObservable.ofType)(_connectToSF.connectCampaignToSFById), (0, _operators.switchMap)(function (_ref2) {
    var campaignId = _ref2.payload;
    return salesforceApiService.post("/salesforce/campaign/".concat(campaignId, "/connect"), null, true).pipe((0, _operators.mergeMap)(function (response) {
      return [(0, _services.showGlobalMessage)({
        text: 'Campaign successfully connected to Salesforce!',
        type: _services.MessageType.Success
      }), (0, _connectToSF.connectCampaignToSFSuccess)(response.data)];
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(_connectToSF.connectCampaignToSFFail))));
  }));
};

exports.connectCampaignToSFEpic = connectCampaignToSFEpic;

var getConnectCampaignToSFStatusEpic = function getConnectCampaignToSFStatusEpic(action$, state$, _ref3) {
  var salesforceApiService = _ref3.salesforceApiService;
  return action$.pipe((0, _reduxObservable.ofType)(_connectToSF.loadCampaignConnectionToSFStatus), (0, _operators.switchMap)(function (_ref4) {
    var campaignId = _ref4.payload;
    return salesforceApiService.get("/salesforce/campaign/".concat(campaignId, "/connection/status"), null, true).pipe((0, _operators.map)(function (response) {
      return (0, _connectToSF.loadCampaignConnectionToSFStatusSuccess)(response.data);
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(_connectToSF.loadCampaignConnectionToSFStatusFail))));
  }));
};

exports.getConnectCampaignToSFStatusEpic = getConnectCampaignToSFStatusEpic;
var _default = [connectCampaignToSFEpic, getConnectCampaignToSFStatusEpic];
exports.default = _default;